import React, { useEffect, useState } from "react";
import { api, i18n } from "@/lib/api";

export default function ProfileHub({ language, profile, onSaved }) {
  const t = i18n[language];
  const [form, setForm] = useState({
    full_name: "",
    university_name: "",
    department_program: "",
    instructor_certifications: "",
    work_experience: "",
    professional_specializations: "",
    institutional_proxy_settings: "",
    anything_else_context: "",
  });
  const [saving, setSaving] = useState(false);
  const [savedFlash, setSavedFlash] = useState(false);

  useEffect(() => {
    if (profile) {
      setForm({
        full_name: profile.full_name || "",
        university_name: profile.university_name || "",
        department_program: profile.department_program || "",
        instructor_certifications: profile.instructor_certifications || "",
        work_experience: profile.work_experience || "",
        professional_specializations: profile.professional_specializations || "",
        institutional_proxy_settings: profile.institutional_proxy_settings || "",
        anything_else_context: profile.anything_else_context || "",
      });
    }
  }, [profile]);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async () => {
    setSaving(true);
    try {
      const result = await api.updateProfile(form);
      onSaved?.(result.profile);
      setSavedFlash(true);
      setTimeout(() => setSavedFlash(false), 1500);
    } finally {
      setSaving(false);
    }
  };

  const field = (id, label, key, multiline = false, type = "text") => (
    <div className="input-line focus-line" style={{ marginBottom: "1.25rem" }}>
      <label className="h-eyebrow" htmlFor={id}>{label}</label>
      {multiline ? (
        <textarea id={id} data-testid={`profile-${id}`} value={form[key]} onChange={set(key)} rows={3} />
      ) : (
        <input id={id} data-testid={`profile-${id}`} type={type} value={form[key]} onChange={set(key)} />
      )}
    </div>
  );

  return (
    <div data-testid="profile-hub">
      <div className="h-eyebrow">{t.profile}</div>
      <h2 className="h-display" style={{ fontSize: "1.4rem", margin: "0.4rem 0 1.2rem" }}>
        {language === "es" ? "Centro del Instructor" : "Instructor Profile Hub"}
      </h2>

      {field("full-name", language === "es" ? "Nombre completo" : "Full Name", "full_name")}
      {field("university", t.universityName, "university_name")}
      {field("department", t.departmentProgram, "department_program")}
      {field("certifications", t.certifications, "instructor_certifications", true)}
      {field("experience", t.workExperience, "work_experience", true)}
      {field("specializations", t.specializations, "professional_specializations", true)}
      {field("proxy", t.proxySettings, "institutional_proxy_settings", true, "password")}
      {field("anything-else", t.anythingElse, "anything_else_context", true)}

      <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
        <button data-testid="profile-save" className="btn-primary" onClick={submit} disabled={saving}>
          {saving ? "..." : t.save}
        </button>
        {savedFlash && <span data-testid="profile-saved-flash" className="txt-accent">{t.saved}</span>}
      </div>
    </div>
  );
}
